import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const BillingDetails = () => {
  return (
    <Card className="shadow-sm border-0 p-4 rounded-4 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h5 className="mb-1">Payment & Billing Detail</h5>
          <p className="text-muted small mb-0">Manage your Billing detail destinations and Billing address</p>
        </div>
        <Link to="payment">
        <Button variant="link" className="text-decoration-none">
            <img
              src="assets/arrow-right-sm.svg"
              alt="Arrow Right"
              className="nav-icon"
            />
        </Button>
        </Link>
      </div>
    </Card>
  );
};

export default BillingDetails;